import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const FileTypeRarIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    className={cn(className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.49444 13.8576C9.613 14.7454 14.7317 14.7155 19.8502 13.8576V6.7415C19.8502 6.66042 19.824 6.58159 19.7753 6.51678L16.4046 2.0224C16.3338 1.92811 16.2228 1.87256 16.105 1.87256H5.61804C5.32006 1.87256 5.03422 1.99094 4.82352 2.20164C4.61282 2.41242 4.49444 2.69818 4.49444 2.99615V11.6104C4.49444 12.1667 4.36401 12.6381 4.36401 13.014C4.36401 13.5335 4.49444 13.8576 4.49444 13.8576Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M2.24719 12.8867V20.9737C2.24719 21.2716 2.36557 21.5575 2.57627 21.7682C2.78697 21.9789 3.07281 22.0973 3.37079 22.0973H20.5993C20.8973 22.0973 21.183 21.9789 21.3938 21.7682C21.6045 21.5575 21.7229 21.2716 21.7229 20.9737C21.7229 19.5385 21.7229 16.4164 21.7229 14.9812C21.7229 14.6832 21.6045 14.3974 21.3938 14.1867C21.183 13.976 20.8973 13.8576 20.5993 13.8576H3.74535C3.26751 13.8576 2.24719 12.8867 2.24719 12.8867Z"
      fill="#E57560"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.37079 13.8577C3.02886 13.8577 2.77924 13.719 2.59551 13.5482C2.42265 13.3875 2.24719 13.1042 2.24719 12.7341C2.24719 12.4965 2.36557 12.1502 2.57627 11.9396C2.78697 11.7289 3.07281 11.6105 3.37079 11.6105H4.49438V13.8577C4.49438 13.8577 4.59065 13.8577 3.37079 13.8577Z"
      fill="#A2584A"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.1049 1.87256V5.61791C16.1049 5.91588 16.2232 6.20173 16.4339 6.41242C16.6446 6.62312 16.9304 6.7415 17.2285 6.7415H19.8501C19.8501 6.66042 19.8239 6.58159 19.7752 6.51678L16.4045 2.0224C16.3337 1.92811 16.2227 1.87256 16.1049 1.87256Z"
      fill="#AFBDC7"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.9312 19.9816L11.985 17.1715L13.0388 19.9816C13.1114 20.1752 13.3274 20.2734 13.521 20.2008C13.7146 20.1282 13.8128 19.9122 13.7402 19.7186L12.3357 15.9733C12.2809 15.8271 12.1411 15.7303 11.985 15.7303C11.8288 15.7303 11.6892 15.8271 11.6343 15.9733L10.2298 19.7186C10.1573 19.9122 10.2554 20.1282 10.449 20.2008C10.6426 20.2734 10.8586 20.1752 10.9312 19.9816Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M11.018 19.2883H12.9213C13.128 19.2883 13.2958 19.1205 13.2958 18.9138C13.2958 18.7071 13.128 18.5392 12.9213 18.5392H11.018C10.8113 18.5392 10.6434 18.7071 10.6434 18.9138C10.6434 19.1205 10.8113 19.2883 11.018 19.2883Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M6.83518 18.5861H8.46988C9.11842 18.5861 9.64417 18.0604 9.64417 17.4118V16.9046C9.64417 16.256 9.11842 15.7303 8.46988 15.7303C7.6395 15.7303 6.46062 15.7303 6.46062 15.7303C6.25379 15.7303 6.08606 15.8979 6.08606 16.1048V19.8501C6.08606 20.0568 6.25388 20.2247 6.46062 20.2247C6.66736 20.2247 6.83518 20.0568 6.83518 19.8501V18.5861ZM6.83518 17.837H8.46988C8.70467 17.837 8.89505 17.6467 8.89505 17.4118V16.9046C8.89505 16.6697 8.70467 16.4793 8.46988 16.4793H6.83518V17.837Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.0748 18.5861H16.7095C17.3581 18.5861 17.8838 18.0604 17.8838 17.4118V16.9046C17.8838 16.256 17.3581 15.7303 16.7095 15.7303C15.8792 15.7303 14.7004 15.7303 14.7004 15.7303C14.4934 15.7303 14.3258 15.8979 14.3258 16.1048V19.8501C14.3258 20.0568 14.4936 20.2247 14.7004 20.2247C14.907 20.2247 15.0748 20.0568 15.0748 19.8501V18.5861ZM15.0748 17.837H16.7095C16.9444 17.837 17.1348 17.6467 17.1348 17.4118V16.9046C17.1348 16.6697 16.9444 16.4793 16.7095 16.4793H15.0748V17.837Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M7.37174 18.5484L9.0103 20.1204C9.15952 20.2635 9.39682 20.2586 9.53992 20.1094C9.68302 19.9602 9.67808 19.723 9.52895 19.5799L7.8903 18.0079C7.74118 17.8648 7.50388 17.8697 7.36077 18.0188C7.21767 18.168 7.22262 18.4053 7.37174 18.5484Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.6114 18.5484L17.25 20.1204C17.3992 20.2635 17.6364 20.2586 17.7795 20.1094C17.9226 19.9602 17.9177 19.723 17.7685 19.5799L16.13 18.0079C15.9808 17.8648 15.7435 17.8697 15.6004 18.0188C15.4573 18.168 15.4622 18.4053 15.6114 18.5484Z"
      fill="#D8DFE3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.487 9.97497V8.4885V8.48805C10.487 8.12419 10.6315 7.77515 10.8888 7.51789C11.146 7.26064 11.495 7.1161 11.8588 7.1161H12.1112C12.4751 7.1161 12.824 7.26064 13.0814 7.51789C13.3386 7.77515 13.4832 8.12419 13.4832 8.48805V9.97497C13.6141 9.91061 13.7347 9.82486 13.8398 9.71978C14.0911 9.46855 14.2322 9.12769 14.2322 8.77228C14.2322 8.76697 14.2322 8.76167 14.2322 8.75646C14.2322 8.44383 14.2706 8.13246 14.3464 7.82918L14.3465 7.829C14.5345 7.07673 14.1117 6.30657 13.3761 6.06136C13.3172 6.04167 13.2577 6.02189 13.1982 6.00203C12.4107 5.73956 11.5594 5.73956 10.7719 6.00203C10.7125 6.02189 10.653 6.04167 10.594 6.06136C9.85837 6.30657 9.43563 7.07673 9.62367 7.829V7.82918C9.69954 8.13246 9.73783 8.44383 9.73783 8.75646V8.77228C9.73783 9.12769 9.87905 9.46855 10.1304 9.71978C10.2354 9.82486 10.3561 9.91061 10.487 9.97497Z"
      fill="#E57560"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M10.4613 5.31597L10.535 5.29144C11.4762 4.97764 12.4938 4.97764 13.435 5.29144L13.5086 5.31597C13.5907 4.33305 13.8697 2.86042 14.7673 1.87256H9.20264C10.1002 2.86042 10.3792 4.33305 10.4613 5.31597Z"
      fill="#E57560"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M12.7341 8.48794V10.0752C12.7341 10.0999 12.7365 10.1244 12.7413 10.1487L12.8883 10.8838C12.9424 11.1543 12.8724 11.4347 12.6976 11.648C12.5227 11.8613 12.2614 11.9849 11.9857 11.9849C11.9852 11.9849 11.9848 11.9849 11.9843 11.9849C11.7085 11.9849 11.4472 11.8613 11.2724 11.648C11.0976 11.4347 11.0275 11.1543 11.0816 10.8838L11.2286 10.1489L11.2359 10.0752V8.48794C11.2359 8.32282 11.3015 8.16435 11.4184 8.04758C11.5351 7.93073 11.6936 7.86511 11.8587 7.86511H12.1111C12.2764 7.86511 12.4348 7.93073 12.5516 8.04758C12.6684 8.16435 12.7341 8.32282 12.7341 8.48794Z"
      fill="#E57560"
      fillRule="evenodd"
    />
  </svg>
);

export default FileTypeRarIcon;
